import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useState, ReactNode } from 'react';
import { toast } from 'react-toastify';
import { IconCopy } from '@assets/icons';

interface ClipboardProps {
  text: string;
  toastMessage: string;
  children?: ReactNode;
  dataTestId?: string;
}

export const Clipboard = ({
  text,
  toastMessage,
  children,
  dataTestId = 'copy-button',
}: ClipboardProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    toast.success(toastMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip data-testid="tooltip-copy" id={`tooltip-${dataTestId}`}>{
          copied ? 'Copiado!' : 'Copiar'
        }</Tooltip>
      }
    >
      <Button
        className="p-0"
        size="sm"
        onClick={handleCopy}
        variant="link"
        data-testid={dataTestId}
      >
        {children ?? <IconCopy fill={'rgb(108, 117, 125)'} />}
      </Button>
    </OverlayTrigger>
  );
};
